import { useMemo } from 'react';
import {
  DataSciencePerformanceAnalyticsQuery,
  useDataSciencePerformanceAnalyticsQuery
} from 'graphql/types';

export const useGetDataSciencePerformanceAnalytics = (): {
  data: DataSciencePerformanceAnalyticsQuery | undefined;
  loading: boolean;
  isEmpty: boolean;
} => {
  const { loading, data } = useDataSciencePerformanceAnalyticsQuery();

  return useMemo(
    () => ({
      data,
      loading,
      isEmpty: data?.dataSciencePerformanceAnalytics?.overallAccuracy === null
    }),
    [data, loading]
  );
};
